import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopBar } from '../navigation/TopBar';

export function AppLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <TopBar />
      <Outlet />
    </div>
  );
}
